export const AMBIENT_TRACKS = [
  { id: "none", label: "Silence" },
  { id: "rain", label: "Rain" },
  { id: "ocean", label: "Ocean" },
  { id: "wind", label: "Night wind" },
];

function noiseBuffer(ctx, seconds = 4) {
  const buf = ctx.createBuffer(1, ctx.sampleRate * seconds, ctx.sampleRate);
  const data = buf.getChannelData(0);
  let last = 0;
  for (let i = 0; i < data.length; i += 1) {
    const white = Math.random() * 2 - 1;
    last = (last + 0.02 * white) / 1.02;
    data[i] = last * 3.5;
  }
  return buf;
}

export class AmbientSound {
  constructor() { this.ctx = null; this.nodes = []; this.master = null; this.track = "none"; this.volume = 0.5; }

  ensure() {
    if (!this.ctx) {
      this.ctx = new (window.AudioContext || window.webkitAudioContext)();
      this.master = this.ctx.createGain();
      this.master.gain.value = this.volume;
      this.master.connect(this.ctx.destination);
    }
    if (this.ctx.state === "suspended") this.ctx.resume();
  }

  setVolume(v) { this.volume = v; if (this.master) this.master.gain.setTargetAtTime(v, this.ctx.currentTime, 0.1); }

  stop() {
    this.nodes.forEach((n) => { try { n.stop?.(); n.disconnect(); } catch (e) { /* already stopped */ } });
    this.nodes = [];
    this.track = "none";
  }

  play(track) {
    this.stop();
    if (track === "none") return;
    this.ensure();
    const ctx = this.ctx;
    const src = ctx.createBufferSource();
    src.buffer = noiseBuffer(ctx);
    src.loop = true;
    const filter = ctx.createBiquadFilter();
    const gain = ctx.createGain();
    const lfo = ctx.createOscillator();
    const lfoGain = ctx.createGain();
    if (track === "rain") { filter.type = "highpass"; filter.frequency.value = 900; gain.gain.value = 0.35; lfo.frequency.value = 0.9; lfoGain.gain.value = 0.06; }
    else if (track === "ocean") { filter.type = "lowpass"; filter.frequency.value = 420; gain.gain.value = 0.3; lfo.frequency.value = 0.08; lfoGain.gain.value = 0.22; }
    else { filter.type = "bandpass"; filter.frequency.value = 300; filter.Q.value = 0.6; gain.gain.value = 0.3; lfo.frequency.value = 0.05; lfoGain.gain.value = 0.18; }
    lfo.connect(lfoGain).connect(gain.gain);
    src.connect(filter).connect(gain).connect(this.master);
    src.start(); lfo.start();
    this.nodes = [src, lfo];
    this.track = track;
  }

  dispose() { this.stop(); if (this.ctx) { this.ctx.close().catch(() => {}); this.ctx = null; this.master = null; } }
}
